var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"sm":"12"}},[_c('TravelsTable',{attrs:{"items":_vm.travels,"hover":"","striped":"","border":"","small":"","fixed":"","caption":"Viajes"},on:{"refresh":_vm.refreshItems,"trefresh":_vm.refreshTab}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }